import { ViewPermissionModel } from "./viewPermissionModel";

export class SidebarReponseModel{
  public sidemenu : ViewPermissionModel
  public childList : Array<ViewPermissionModel> = []
}
